// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__1cKOk","icon":"search_icon__3vGpx","input":"search_input__3i83-","button":"search_button__25qXM"};